// useIsMobile.js
import { useState, useEffect } from 'react';

const QUERY = '(max-width: 768px)';

// Single source of truth for "is this a mobile viewport" — used by the app shell (sidebar drawer),
// DataTable (compact list-card rows instead of a table), modals (full-screen sheets), and any
// page needing to branch its layout. matchMedia + a change listener rather than a resize listener
// directly, so it only re-renders when the breakpoint is actually crossed, not on every pixel of
// a resize/drag.
function useIsMobile() {
  const [isMobile, setIsMobile] = useState(() => (
    typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(QUERY).matches : false
  ));

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined;
    const mql = window.matchMedia(QUERY);
    const handleChange = (e) => setIsMobile(e.matches);
    mql.addEventListener('change', handleChange);
    setIsMobile(mql.matches);
    return () => mql.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}

export default useIsMobile;
